export default {
	sags: '/images/clients/sags/sags-logo.png',
};
